import { render } from "./ItemFolder.vue?vue&type=template&id=fdb958de&scoped=true&ts=true"
import script from "./ItemFolder.vue?vue&type=script&lang=ts"
export * from "./ItemFolder.vue?vue&type=script&lang=ts"

import "./ItemFolder.vue?vue&type=style&index=0&id=fdb958de&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb958de"]])

export default __exports__